export enum UserStatus {
        All=0,
        AccountInitiated = 1,
        AccountInitiatedAndInvited = 2,
        AccountActivated = 3,
        AccountDeactivated = 4,
}